import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {BackendApiService} from "../../../../../../services/backend-api.service";
import {StaffService} from "../../../../../../services/staff/staff.service";

const USERS_PER_PAGE = 12;

@Component({
    selector: 'app-observer-participant-popup',
    templateUrl: './observer-participant-popup.component.html',
    styleUrls: ['./observer-participant-popup.component.scss'],
    standalone: false
})
export class ObserverParticipantPopupComponent implements OnInit {

  public type: any;
  public index: any;
  usersList: any = [];
  vendorsList: any = [];
  customersList: any = [];
  subcontractorsList: any = [];
  selectedIndex: any = 0;
  TYPE_USER: any = 'Users';
  TYPE_VENDORS: any = 'Vendors';
  TYPE_CUSTOMERS: any = 'Customers';
  TYPE_SUBCONTRACTORS: any = 'Subcontractors';

  isLoadingUsers = false;
  isLoadingMore = false;
  currentPage = 1;
  hasMore = true;
  searchTerm = '';
  readonly skeletonRows = Array.from({ length: 6 });
  readonly loadMoreSkeletonRows = Array.from({ length: 2 });

  constructor(
    public dialogRef: MatDialogRef<ObserverParticipantPopupComponent>,
    public backendApiService: BackendApiService,
    public staffService: StaffService,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.type = this.data?.type;
    this.index = this.data?.index
  }

  ngOnInit(): void {
    // Populate the panel up front. Without this the popup opens blank and the
    // user has to type-and-blur before seeing anyone.
    this.loadUsers();
  }

  /**
   * An empty term is deliberate: the backend wraps it as LIKE '%%', which
   * matches every staff member, so this doubles as "show all".
   */
  loadUsers(search: string = '', page: number = 1) {
    const isFirstPage = page === 1;
    this.searchTerm = search;

    if (isFirstPage) {
      this.isLoadingUsers = true;
      this.usersList = [];
    } else {
      this.isLoadingMore = true;
    }

    this.backendApiService.getApi('staff/search', { search, page, per_page: USERS_PER_PAGE })
      .subscribe({
        next: (response: any) => {
          const processed = this.staffService.processStaff(response.data);
          this.usersList = isFirstPage ? processed : [...this.usersList, ...processed];
          this.currentPage = response.meta?.current_page ?? page;
          this.hasMore = this.currentPage < (response.meta?.last_page ?? this.currentPage);
        },
        complete: () => {
          this.isLoadingUsers = false;
          this.isLoadingMore = false;
        },
      });
  }

  getUsersList(event: any) {
    this.loadUsers(event?.target?.value ?? '', 1);
  }

  onListScroll(event: any) {
    if (this.isLoadingUsers || this.isLoadingMore || !this.hasMore) {
      return;
    }
    const el = event.target;
    const threshold = 40;
    if (el.scrollTop + el.offsetHeight >= el.scrollHeight - threshold) {
      this.loadUsers(this.searchTerm, this.currentPage + 1);
    }
  }

  getVendorsList(event: any) {
    this.backendApiService.postApi(`vendors?search=${event?.target?.value}`,'')
      .subscribe((response: any) => {
        console.log('response:',response);
        this.vendorsList = response.data;
      })
  }

  getCustomersList(event: any) {
    this.backendApiService.postApi(`customers?search=${event?.target?.value}`,'')
      .subscribe((response: any) => {
        console.log('response:',response);
        this.customersList = response.data;
      })
  }

  getSubcontractorsList(event: any) {
    this.backendApiService.postApi(`subcontractors?search=${event?.target?.value}&is_related_view=true`,'')
      .subscribe((response: any) => {
        console.log('response:',response);
        this.subcontractorsList = response.data;
      })
  }


  close(data: any = '') {
    this.dialogRef.close(data);
  }

  getActiveTab(event: any){
    console.log('hlele',event);
    this.selectedIndex = event;
  }

  getTabNameUsingTabIndex(index: any) {
    let value = '';
    switch (index) {
      case 0:
        value = this.TYPE_USER;
        break;
      case 1:
        value = this.TYPE_VENDORS;
        break;
      case 2:
        value = this.TYPE_CUSTOMERS
        break;
      case 3:
        value = this.TYPE_SUBCONTRACTORS;
        break;
      default:
    }
    return value;
  }
}
